export type FirebaseInstance = any

const config = {
  apiKey: 'AIzaSyDfxhpHJdf85gT7Wk4CoW9goh0iobC6ZC8',
  authDomain: 'x-kite.firebaseapp.com',
  projectId: 'x-kite',
  storageBucket: 'x-kite.appspot.com',
  messagingSenderId: '960640478043',
  appId: '1:960640478043:web:930684039abd572001087e',
  measurementId: 'G-D51WS67XN6'
}

/*
  Firebase does not work in a server environment as it requires access to the browser's fetch API
  This is a workaround to allow us to use Firebase in the browser without failing Gatsby's build process
*/

class FirebaseService {
  private _instance: FirebaseInstance = null

  private _initPromise: Promise<FirebaseInstance> | null = null

  get instance() {
    return this._instance
  }

  async initialize(): Promise<FirebaseInstance> {
    if (this._instance) return this._instance
    if (this._initPromise) return this._initPromise

    this._initPromise = this._load()
    return this._initPromise
  }

  private async _load(): Promise<FirebaseInstance> {
    const fbApp = await import('@firebase/app-compat')
    await import('@firebase/auth-compat').catch(() => logger.warn('Failed to load firebase auth module'))
    await import('@firebase/analytics-compat').catch(() => logger.warn('Failed to load firebase analytics module'))

    const firebase = fbApp.default

    if (!firebase.apps.length) {
      firebase.initializeApp(config)
    }

    this._instance = firebase
    return firebase
  }
}

export const firebaseService = new FirebaseService()

/** @deprecated use firebaseService.instance */
export const cachedFirebaseInstance: FirebaseInstance = null

export async function getFirebase(): Promise<FirebaseInstance> {
  return firebaseService.initialize()
}

export async function getFirebaseAuth() {
  const firebase = await getFirebase()
  return firebase.auth
}
